import { number } from 'yup';
import { FieldType } from '@widgets/EnquiryForm/types/config';
export const generateNumberSchemaObject = ({ type, required, max, min, }) => {
    if (type !== FieldType.NumberInput)
        return null;
    let fieldValidation = number();
    fieldValidation = fieldValidation.typeError('Field must contain a number');
    if (required) {
        fieldValidation = fieldValidation.required('This is a required field');
    }
    if (min) {
        fieldValidation = fieldValidation.min(min, `Please enter ${min} or above`);
    }
    if (max) {
        fieldValidation = fieldValidation.max(max, `Please enter ${max} or below`);
    }
    return fieldValidation;
};
